import { SET_STATS } from '../types';

export default (state = {}, action) => {
    switch (action.type) {
        case SET_STATS:
            return { ...state, [action.name]: action.payload }
        default:
            return state;
    }
}